import SelectorImagesContainer from 'components/SelectorImages/SelectorImagesContainer'

export default {
  Container: SelectorImagesContainer,
}
